import React, { Component } from 'react';
import { seebizCloudUrl } from '../../../Helpers/UrlHelper';
import './DashboardFooter.css';
import { t } from 'i18next';

var d = new Date();
var n = d.getFullYear();
const seebizUrl = seebizCloudUrl();

export default class DashboardFooter extends Component {
  render() {
    return (
      <div className="dashboard_footer">
        <p>{t('Preferences.copyright')} &copy; {n} {t('Preferences.seebiz_Inc')}</p>
        <p>
          <a href={`https://www.${seebizUrl}/page/terms`} target="blank">
            {t('Preferences.terms_conditions')}
          </a>{' '}
          |{' '}
          <a href={`https://www.${seebizUrl}/page/privacy`} target="blank">
            {t('Preferences.privacy_policy')}
          </a>{' '}
          | <a href="tel:+1 213 986 9911">+1 213 986 9911</a> |{' '}
          <a href="mailto:support@seebiz-inventory.com">
            support@seebiz-inventory.com
          </a>
        </p>
      </div>
    );
  }
}
